import { render, staticRenderFns } from "./eventos-e-actividades.vue?vue&type=template&id=3dc752fc&scoped=true&"
import script from "./eventos-e-actividades.vue?vue&type=script&lang=js&"
export * from "./eventos-e-actividades.vue?vue&type=script&lang=js&"
import style0 from "./eventos-e-actividades.vue?vue&type=style&index=0&id=3dc752fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc752fc",
  null
  
)

export default component.exports